import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import MapContainer from './map-container';
import { getCommunities } from '../redux/actions/communities';
import ResultsContainer from './results-container';
import Breadcrumbs from './breadcrumbs';
import { getSettings } from '../util/getSettings';
import FiltersContainer from './filters-container';
import {
  priceRangeUpdated,
  bedBathsUpdated,
  homeTypesUpdated,
  brandUpdated,
  squareFeetUpdated,
  baysUpdated,
  floorsUpdated,
  mpcOnlyUpdated,
  filtersUpdated,
  quickMoveInUpdated,
} from '../redux/actions/filters';
import { getSearchRegionData } from '../redux/actions/regionData';
import { regionDefaults } from '../util/regions';
import { getRegionState } from '../util/regions';
import { setBBReady } from '../redux/actions/mortgageCalc';

let newSeed;

if(newSeed ==null){    
  newSeed = Math.floor(Date.now() / 1000);  
}
const Fyh = () => {
  const settings = getSettings(['century', 'settings']);
  const filters = useSelector((state) => state.filters);
  const mapState = useSelector((state) => state.map);
  const markerDataState = useSelector(state => state.markerData);
  const regionData = useSelector(state => state.regionData);
  const standalonePage = settings.standalonePage ?? false
  const communities = useSelector((state) => state.communities);
  const dispatch = useDispatch();

  useEffect(() => {
    window.century = window.century || {};
    window.century.updateStateData = (stateName, stateAbbrev) => {
      const newRegionData = getRegionState(stateAbbrev);
      dispatch(getSearchRegionData({ contentId: newRegionData.ContentId }));
      dispatch(diUpdated(newRegionData.ContentId));
      new QsStateManager().addParam('di', newRegionData.ContentId, Number(qstr('di'))).addFilters(getFiltersFromQs()).doUpdate();
    };
    window.century.regionDataStash = [ regionDefaults ];
    window.onpopstate = event => {
      const evtState = event.state;
      if (evtState !== null) {
        dispatch(priceRangeUpdated(evtState.minPrice, evtState.maxPrice));
        dispatch(bedBathsUpdated(evtState.bedrooms, evtState.bathrooms));
        dispatch(homeTypesUpdated(evtState.homeTypes));
        dispatch(brandUpdated(evtState.brand));
        dispatch(squareFeetUpdated(evtState.minSquareFeet, evtState.maxSquareFeet));
        dispatch(baysUpdated(evtState.bays));
        dispatch(floorsUpdated(evtState.floors));
        dispatch(mpcOnlyUpdated(evtState.mpcOnly));
        dispatch(quickMoveInUpdated(evtState.quickMoveIn));
        dispatch(filtersUpdated());
      }
    };

    window.addEventListener('BB-ready', () => {
      window.bbReady = true
      dispatch(setBBReady(true))
    });
  },[]);

  useEffect(() => {
    window.century.currentState = regionData.stateName;
    window.century.regionDataStash.filter(x => x.regionId === regionData.regionId).length === 0 && window.century.regionDataStash.push(regionData);
  }, [regionData.timeStamp]);

  useEffect(() => {
    const activeResult = markerDataState.activeResult;
    const lgBreakpoint = Number(getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-lg').replace('px', ''));
    const screenWidth = window.innerWidth;

    if (screenWidth >= lgBreakpoint && !communities.isFetching && activeResult && activeResult.name) {
      const resultsContainer = document.getElementById('resultsContainer') 
      const activeElement = document.getElementById(activeResult.name);
      const mainNavOffset = document.body.classList.contains('scroll-up') ? document.getElementsByClassName('header__nav')[0].offsetHeight : 0
      const windowScroll = window.scrollY;
      const containerOffset = resultsContainer.offsetTop;

      resultsContainer.scrollTo({
        top: activeElement.offsetTop - (windowScroll > containerOffset ? windowScroll : containerOffset), 
        behavior: 'smooth'
      })

      if (mainNavOffset && windowScroll > containerOffset) {
        window.scrollTo({
          top: containerOffset - mainNavOffset, 
          behavior: 'smooth'
        })
      }
    }
  }, [markerDataState.activeResult]);

  useEffect(() => {
    const googleMapFilters = {
      minPrice: filters.minPrice,
      maxPrice: filters.maxPrice === settings.maxPrice ? 999999999999 : filters.maxPrice,
      bedrooms: filters.bedrooms,
      bathrooms: filters.bathrooms,
      minSquareFeet: filters.minSquareFeet,
      maxSquareFeet: filters.maxSquareFeet,
      sortBy: filters.sortBy,
      asc: filters.asc,
      metro: regionData.metroName,
      city: regionData.cityName,
      startIndex: 0,
      resultType: settings.resultType,
      initState: regionData.initState,
      guestCommunityIds: regionData.guestCommunityIds,
      mapShown: mapState.visible,
      pageNumber: 0, // page number is a 0-based index and should always be 0 for the map view
      seed: newSeed,
    };

    if (filters.homeTypes) googleMapFilters.homeTypes = filters.homeTypes;
    if (filters.bays) googleMapFilters.bays = filters.bays;
    if (filters.floors) googleMapFilters.floors = filters.floors;
    if (filters.brand) googleMapFilters.brand = filters.brand;
    if (filters.quickMoveIn) googleMapFilters.quickMoveIn = filters.quickMoveIn;
    if (filters.mpcOnly) googleMapFilters.mpCommunitiesOnly = filters.mpcOnly;

    if (mapState.bounds) {           
      const center = mapState.bounds.getCenter();
      const sw = mapState.bounds.getSouthWest();
      const ne = mapState.bounds.getNorthEast();
      const swLng = sw.lng();
      const neLng = ne.lng();

      if (swLng !== neLng) {
        googleMapFilters.centerLat = center.lat();
        googleMapFilters.centerLng = center.lng();
        googleMapFilters.swLat = sw.lat();
        googleMapFilters.neLat = ne.lat();
        googleMapFilters.swLng = swLng;
        googleMapFilters.neLng = neLng;
      }

      dispatch(getCommunities(googleMapFilters));

    } else if (mapState.visible === false) {        
      googleMapFilters.centerLat = settings.initLat;
      googleMapFilters.centerLng = settings.initLng;
      dispatch(getCommunities(googleMapFilters));
    }
  }, [mapState.timeStamp, filters.timeStamp]);

  return (
    <div className="fyh">
      {standalonePage && <Breadcrumbs />}
      <FiltersContainer />
      <div className={`results-wrapper ${mapState.visible ? 'show-map' : ''}`}>
        <ResultsContainer />
        <MapContainer />
      </div>
    </div>
  );
};

export default Fyh;
